/**
 * DashboardCards.jsx — Phase 147 (Dashboard Cleanup). Small presentational
 * building blocks shared by the People/Projects/Finance tab components.
 */
import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export function Card({ title, hint, to, icon: Icon, children, testId }) {
  return (
    <div className="card-flat overflow-hidden flex flex-col" data-testid={testId}>
      <div className="px-5 py-3 border-b border-slate-100 flex items-center justify-between">
        <div className="flex items-center gap-2 min-w-0">
          {Icon && <Icon size={14} className="text-[#F54800] shrink-0" />}
          <div>
            <div className="font-display font-bold text-sm text-slate-900">{title}</div>
            {hint && <div className="text-[10px] text-slate-500">{hint}</div>}
          </div>
        </div>
        {to && (
          <Link to={to} className="text-[11px] text-[#F54800] hover:underline inline-flex items-center gap-0.5 shrink-0">
            View all <ChevronRight size={12} />
          </Link>
        )}
      </div>
      <div className="p-4 flex-1 min-h-[120px]">{children}</div>
    </div>
  );
}

export function TileLink({ to, label, value, accent, icon: Icon, testId }) {
  return (
    <Link to={to} className="card-flat p-4 hover:border-[#F54800] transition-colors block" data-testid={testId}>
      <div className="flex items-center justify-between mb-2">
        <span className="label-overline">{label}</span>
        {Icon && <Icon size={13} className="text-slate-400" />}
      </div>
      <div className={`font-display text-2xl sm:text-3xl font-bold ${accent || "text-slate-900"}`}>{value}</div>
    </Link>
  );
}
